import { SVGProps } from "react";

export function ChevronLeft({ ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.666"
      height="78.169"
      viewBox="0 0 24.666 78.169"
      {...rest}
    >
      <g id="Seta_Carrossel" transform="translate(-1220.22 -2744.152)">
        <path
          id="Path_749"
          data-name="Path 749"
          d="M15.637,0,0,37.347,15.637,74.694"
          transform="translate(1240.008 2820.583) rotate(180)"
          fill="none"
          stroke="#898989"
          stroke-width="9"
        />
      </g>
    </svg>
  );
}
